import { IconCheck } from "../icons/IconCheck";

export function ButtonCheck({
  onClick,
  disabled,
  title,
}: {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      className="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 hover:bg-green-200 dark:bg-green-900/40 dark:hover:bg-green-800/60 border border-green-300 dark:border-green-700 text-green-600 dark:text-green-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
      title={title ?? "Confirm"}
      onClick={onClick}
      disabled={disabled}
    >
      <IconCheck />
    </button>
  );
}
